import { render } from "./TypeOfEquipmentPage.vue?vue&type=template&id=7f4a7644&scoped=true&ts=true"
import script from "./TypeOfEquipmentPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TypeOfEquipmentPage.vue?vue&type=script&lang=ts&setup=true"

import "./TypeOfEquipmentPage.vue?vue&type=style&index=0&id=7f4a7644&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f4a7644"],['__file',"src/pages/settings/pages/typeEquipment/TypeOfEquipmentPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f4a7644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f4a7644', __exports__)) {
    api.reload('7f4a7644', __exports__)
  }
  
  module.hot.accept("./TypeOfEquipmentPage.vue?vue&type=template&id=7f4a7644&scoped=true&ts=true", () => {
    api.rerender('7f4a7644', render)
  })

}


export default __exports__